import axios from 'axios';

import config from '@breathelife/config/frontend';
import {
  addErrorRedirectInterceptor,
  addJwtIntoHeaderInterceptor,
  addProductIntoHeaderInterceptor,
  addTraceIntoHeaderInterceptor,
  Gateway,
  Redirects,
} from '@breathelife/gateway';
import { getTraceId, monitoringInterceptor, ProductName } from '@breathelife/monitoring-frontend';

const ApiService = axios.create();

export function initializeApiServiceInterceptors(errorRedirects: Redirects): void {
  ApiService.interceptors.request.use(addProductIntoHeaderInterceptor(ProductName.ConsumerFlow));
  ApiService.interceptors.request.use(addTraceIntoHeaderInterceptor(getTraceId()));
  ApiService.interceptors.response.use((response) => response, addErrorRedirectInterceptor(errorRedirects));
  ApiService.interceptors.response.use((response) => response, monitoringInterceptor);
}

let authorizationInterceptorIndex: number;
// Add header authorization token
export function setAuthorizationInterceptor(token?: string): void {
  if (typeof authorizationInterceptorIndex !== 'undefined') {
    ApiService.interceptors.request.eject(authorizationInterceptorIndex);
  }

  authorizationInterceptorIndex = ApiService.interceptors.request.use(addJwtIntoHeaderInterceptor(token));
}

const releaseVersion = config.get<string>('git.commitSha');

export default new Gateway(releaseVersion, ApiService);
